module.exports = __webpack_public_path__ + "img/qbcgBg.99ca0c91.png";